import './style/content.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';

function OurClient() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const clients = [
    '/assets/logo1.png',
    '/assets/logo2.jpeg',
    '/assets/logo3.jpg',
    '/assets/logo4.jpg',
    '/assets/logo5.png',
    '/assets/logo6.png',
    '/assets/logo7.png',
    '/assets/logo8.png',
    '/assets/logo9.png',
    '/assets/logo10.png',
    '/assets/logo11.png',
    '/assets/logo12.webp',
    '/assets/logo13.png',
    '/assets/logo14.png',
    '/assets/logo15.png',
    '/assets/logo16.jpeg',
    '/assets/logo17.png',
    '/assets/logo18.jpeg',
    '/assets/logo19.png',
    '/assets/logo20.png',
    '/assets/logo21.png',
    '/assets/logo22.png',
    '/assets/logo23.png',
    '/assets/logo24.png',
    '/assets/logo25.png',
    '/assets/logo26.png',



  ];

  // Gandakan agar infinite
  const infiniteClients = [...clients, ...clients];

  return (
    <section id="our-client" className="ourclient-section">
      <div className="container">
        <h1 className="text-center whyus-title" data-aos="fade-up">
          <span style={{ color: '#FFD54F' }}>Our</span>{" "}
          <span style={{ color: '#1F2937' }}>Client</span>
        </h1>
        <hr className="whyus-hr" data-aos="zoom-in" data-aos-delay="200" />

        <p
          className="text-center whyus-subtitle"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          Trusted by 50+ Brands & Companies
        </p>

        {/* 3 BARIS SLIDER */}
        <div className="client-slider">
          {/* Row 1 */}
          <div className="client-track left">
            {infiniteClients.map((logo, idx) => (
              <div className="client-card" key={`r1-${idx}`}>
                <img src={logo} alt={`Client ${idx + 1}`} />
              </div>
            ))}
          </div>

          {/* Row 2 */}
          <div className="client-track right">
            {infiniteClients.map((logo, idx) => (
              <div className="client-card" key={`r2-${idx}`}>
                <img src={logo} alt={`Client ${idx + 1}`} />
              </div>
            ))}
          </div>

          {/* Row 3 */}
        </div>
      </div>
    </section>
  );
}

export default OurClient;
